import { Event } from '../Event'
import { ViewerContext } from '../../constants'

export interface PathClientFlowEntityCreatedEventProperties {
  path_graph_flow_id: string
  entity_created_id: string
  entity_created_type: string
}

export class PathClientFlowEntityCreatedEvent extends Event<
  PathClientFlowEntityCreatedEventProperties
> {
  static displayName = 'Path Client Flow Entity Created'

  static allowedViewerContexts = [ViewerContext.Consumer]
}
